import { render, staticRenderFns } from "./activity-workshop-collect.vue?vue&type=template&id=264e92ad&scoped=true&"
import script from "./activity-workshop-collect.vue?vue&type=script&lang=js&"
export * from "./activity-workshop-collect.vue?vue&type=script&lang=js&"
import style0 from "./activity-workshop-collect.vue?vue&type=style&index=0&id=264e92ad&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264e92ad",
  null
  
)

export default component.exports